import { render, staticRenderFns } from "./SortButton.vue?vue&type=template&id=f90d390a&scoped=true"
import script from "./SortButton.vue?vue&type=script&lang=js"
export * from "./SortButton.vue?vue&type=script&lang=js"
import style0 from "./SortButton.vue?vue&type=style&index=0&id=f90d390a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90d390a",
  null
  
)

export default component.exports